import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { useSensitiveInfoInputContext } from '../../../../Context';

const styles = () => ({
  root: {},
});

const LockedInputEditAdornment = ({
  className,
  classes,
  color,
  ariaLabel,
}) => {
  const { unlockInput } = useSensitiveInfoInputContext();

  return (
    <InputAdornment position="end">
      <IconButton
        className={classNames(className, classes.root)}
        icon={EditIcon}
        aria-label={ariaLabel}
        title={'Edit Value'}
        onClick={() => {
          unlockInput();
        }}
        onMouseDown={(event) => event.preventDefault()}
        color={color}
      />
    </InputAdornment>
  );
};

LockedInputEditAdornment.defaultProps = {
  className: '',
  color: 'primary',
  ariaLabel: 'Edit field',
};

LockedInputEditAdornment.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  color: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default withStyles(styles)(LockedInputEditAdornment);
